module.exports = __webpack_public_path__ + "static/media/skyBreakingBad.c79c09d0.jpg";